module.exports = "<div class=\"_map\">\n\n  <gmap-map v-if=\"shouldLoadMap\" :center=\"center\" :markers=\"markers\" :zoom=\"zoom\" map-type-id=\"roadmap\" class=\"card\" style=\"height: 100%\">\n    <gmap-marker\n            :key=\"index\"\n            v-for=\"(m, index) in markers\"\n            :position=\"m.position\"\n            :clickable=\"true\"\n            :draggable=\"true\"\n            @click=\"center=m.position\"\n    ></gmap-marker>\n  </gmap-map>\n\n  <v-flex col md12 v-if=\"!shouldLoadMap\">\n    <p class=\"no-map-message\">{{$t(\"no_map\")}}</p>\n  </v-flex>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/plain/map/map.vue
// module id = 438
// module chunks = 0